var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.566897 8.6314L8.63139 0.566906C9.38725 -0.188956 10.6127 -0.188957 11.3686 0.566905L19.4331 8.6314C20.189 9.38726 20.189 10.6128 19.4331 11.3686L11.3686 19.4331C10.6127 20.189 9.38725 20.189 8.63139 19.4331L0.566897 11.3686C-0.188965 10.6128 -0.188965 9.38726 0.566897 8.6314ZM9.54379 1.47932L1.4793 9.54381C1.22735 9.79577 1.22735 10.2043 1.4793 10.4562L9.5438 18.5207C9.79575 18.7727 10.2042 18.7727 10.4562 18.5207L18.5207 10.4562C18.7726 10.2043 18.7726 9.79577 18.5207 9.54381L10.4562 1.47932C10.2042 1.22737 9.79575 1.22737 9.54379 1.47932ZM9.99901 4.027C10.3299 4.027 10.6026 4.27606 10.6398 4.59693L10.6442 4.67217V11.998C10.6442 12.3543 10.3553 12.6431 9.99901 12.6431C9.66814 12.6431 9.39545 12.3941 9.35818 12.0732L9.35384 11.998V4.67217C9.35384 4.31585 9.64269 4.027 9.99901 4.027ZM9.99901 13.6837C9.45879 13.6837 9.02085 14.1216 9.02085 14.6618C9.02085 15.2021 9.45879 15.64 9.99901 15.64C10.5392 15.64 10.9772 15.2021 10.9772 14.6618C10.9772 14.1216 10.5392 13.6837 9.99901 13.6837ZM9.99901 14.3496C10.1714 14.3496 10.3112 14.4894 10.3112 14.6618C10.3112 14.8342 10.1714 14.974 9.99901 14.974C9.8266 14.974 9.68683 14.8342 9.68683 14.6618C9.68683 14.4894 9.8266 14.3496 9.99901 14.3496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group-3.f37f82748d9be798ea00cc7419e4c783.svg";
export { ForwardRef as ReactComponent };